exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rename-collection[data-v-1a2c6cbc]{position:absolute;top:8px;left:25px;width:280px;background-color:#fff;z-index:1}", ""]);

// exports
